module.exports = __webpack_public_path__ + "static/vorpal_sword-9148b26dff1f26e34eda2a5fcb599266.jpeg";